module.exports = __webpack_public_path__ + "static/img/img_awards_1.af06c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/img_awards_1.png
// module id = H56T
// module chunks = 15